import styled from 'styled-components';
import { breakpoints } from 'utils/rwd';

const BREAKPOINT_KEYS = Object.keys(breakpoints);

const resolveResponsiveProp = (cssProp, value, formatValue = (v) => v) => {
  if (value == null) return '';

  if (typeof value !== 'object') {
    return `${cssProp}: ${formatValue(value)};`;
  }

  const base = value.default != null ? `${cssProp}: ${formatValue(value.default)};` : '';

  const mediaRules = BREAKPOINT_KEYS.filter((bp) => value[bp] != null)
    .map(
      (bp) => `
      @media (min-width: ${breakpoints[bp]}px) {
        ${cssProp}: ${formatValue(value[bp])};
      }
    `,
    )
    .join('');

  return `${base}${mediaRules}`;
};

const spanFormat = (v) => `span ${v}`;

export const OptionsSlot = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 32px;
  visibility: hidden;
  z-index: 999;
`;

export const DragHandle = styled.button`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 1000;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.85);
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
  touch-action: none;

  &:hover {
    background: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.3);
  }

  &:active {
    cursor: grabbing;
  }
`;

export const Container = styled.div`
  width: 100%;
  min-width: 0;
  position: relative;
  cursor: default;
  opacity: ${({ $isDragging }) => ($isDragging ? 0.6 : 1)};
  ${({ $gridColumnSpan }) => resolveResponsiveProp('grid-column', $gridColumnSpan, spanFormat)}
  ${({ $gridRowSpan }) => resolveResponsiveProp('grid-row', $gridRowSpan, spanFormat)}
  ${({ $aspectRatio }) => resolveResponsiveProp('aspect-ratio', $aspectRatio)}

  &:hover ${OptionsSlot} {
    visibility: visible;
  }
`;

export const DraggableItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
`;
